<div *ngFor="let content of slide.content; let i = index; trackBy: utils.trackByIndex">
    <!-- header -->
    <h2 class="desktop-only">Congrats, you finished! Here are your results:</h2>

    <image-quiz
        [resultData]="{
            contentIndex: i,
            questionLength: length
        }"
        [slide]="slide">
    </image-quiz>

</div>

<!-- progress -->
<div class="progress"><a class="bar primary-background" style="width: 100%;"></a><span class="percent ">100%</span></div>
